// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"04a83c00","56":"9769bd68","70":"993f8d50","143":"db14df71","182":"5f72afc0","195":"1a5d21c9","219":"ff81d631","403":"c9cd3971","552":"2f20f32d","722":"45f4126e","751":"ec2b51a3","794":"7cc80d90","936":"276ff7a6","991":"45a20bc1"}[chunkId] + ".chunk.js";
};